import Employments from "./Employment";

export default class ClaimDetails {
	constructor() {
		this.ClaimDetailsId = null;
		this.harrassmentExperienced = null;
		this.employments = [new Employments()];
	}
}
